<template>
  <div class="equipment-page">

    <!-- 鼠标光晕 -->
    <div class="cursor-glow" ref="cursorGlow"></div>

    <!-- =================== Hero =================== -->
    <div class="hero" ref="hero">
      <div class="orb orb--1" ref="orb1"></div>
      <div class="orb orb--2" ref="orb2"></div>
      <div class="hero__overlay"></div>

      <div class="hero__body">
        <div class="hero__badge" ref="heroBadge">
          <span class="hero__dot"></span>智能终端设备
        </div>
        <div class="clip-wrap">
          <h1 class="hero__title clip-inner">推动企业<br />让采购更加智能、高效、透明</h1>
        </div>
        <div class="clip-wrap" style="margin-top:.6rem;">
          <p class="hero__sub clip-inner">Promote enterprises · Make procurement more intelligent, efficient and transparent</p>
        </div>
        <div class="hero__actions" ref="heroActions">
          <button class="btn-primary magnetic" @click="applyShow">立即申请试用</button>
          <button class="btn-ghost magnetic">查看规格详情</button>
        </div>

        <!-- Hero 数据 -->
        <div class="hero__stats" ref="heroStats">
          <div class="hero__stat" v-for="s in heroStatData" :key="s.label">
            <div class="hero__stat-row">
              <span class="hero__stat-num" :data-target="s.num">0</span>
              <span class="hero__stat-unit">{{ s.unit }}</span>
            </div>
            <p class="hero__stat-label">{{ s.label }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- =================== 设备网格 =================== -->
    <div class="products-section" ref="prodSection">
      <div class="sec__inner">

        <!-- Section 标题 -->
        <div class="sec__head" ref="secHead">
          <span class="sec__label reveal-chip">PRODUCT SERVICE</span>
          <div class="title-mask">
            <h2 class="title-mask__inner">产品服务</h2>
          </div>
          <p class="sec__desc" ref="secDesc">多款智能终端，满足不同场景的收款与管理需求</p>
        </div>

        <!-- 3×N 卡片网格 -->
        <div class="equip-grid">
          <div
            v-for="(item, index) in imgData"
            :key="index"
            class="equip-card"
            ref="equipCards"
          >
            <!-- 深色产品展示区 -->
            <div class="equip-card__stage">
              <!-- 底部发光台 -->
              <div class="equip-card__glow"></div>
              <img :src="item.img" :alt="item.name" class="equip-card__img" />
              <!-- 品类标 -->
              <span class="equip-card__cat">{{ item.category }}</span>
            </div>

            <!-- 规格内容区 -->
            <div class="equip-card__body">
              <!-- 背景序号 -->
              <span class="equip-card__bg-num" aria-hidden="true">{{ String(index + 1).padStart(2, '0') }}</span>

              <h3 class="equip-card__name">{{ item.name }}</h3>
              <div class="equip-card__bar"></div>

              <div class="equip-card__specs">
                <!-- 主屏 -->
                <div class="spec-row">
                  <span class="spec-badge spec-badge--main">主屏</span>
                  <span class="spec-text">{{ item.msg1 }}</span>
                </div>
                <!-- 副屏 -->
                <div class="spec-row">
                  <span class="spec-badge" :class="item.msg2 !== '无' ? 'spec-badge--sub' : 'spec-badge--none'">副屏</span>
                  <span class="spec-text" :class="{ 'spec-text--none': item.msg2 === '无' }">{{ item.msg2 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <ApplyDialog :show.sync="show"></ApplyDialog>
  </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import ApplyDialog from '../components/applyDialog.vue'

gsap.registerPlugin(ScrollTrigger)

export default {
  components: { ApplyDialog },
  data() {
    return {
      show: false,
      heroStatData: [
        { num: 9,   unit: '款',  label: '终端型号' },
        { num: 500, unit: '+',   label: '合作商户' },
        { num: 3,   unit: '大类', label: '设备分类' },
      ],
      imgData: [
        { img: require('../assets/equipment1.png'), name: 'FT1 海马一代',       category: '刷脸终端', msg1: '7寸、分辨率1024*600、多点触摸电容屏',         msg2: '4寸、分辨率400*800' },
        { img: require('../assets/equipment2.png'), name: '新开普 A832',         category: '刷脸终端', msg1: '8寸、分辨率1280*800、多点触摸电容屏',         msg2: '5寸、分辨率1280*720、多点触摸电容屏' },
        { img: require('../assets/equipment3.png'), name: '乐舜 LSF910',         category: '刷脸终端', msg1: '8寸、分辨率800*1280、多点触摸电容屏',         msg2: '5寸、分辨率480*854、多点触摸电容屏' },
        { img: require('../assets/equipment4.png'), name: 'FT1 海马一代（支架）',  category: '刷脸终端', msg1: '7寸、分辨率1024*600、多点触摸电容屏',         msg2: '4寸、分辨率480*800' },
        { img: require('../assets/equipment5.png'), name: '新开普 A732',         category: '刷脸终端', msg1: '8寸、分辨率1280*800、多点触摸电容屏',         msg2: '5寸、分辨率1280*720、多点触摸电容屏' },
        { img: require('../assets/equipment6.png'), name: '商米 D2',             category: 'PC 收银台', msg1: '15.6寸，分辨率1366*768',                   msg2: '10.1寸，分辨率1024*600' },
        { img: require('../assets/equipment6.png'), name: '天波 TPS650 双屏',    category: 'PC 收银台', msg1: '15.6寸，分辨率1920*1080，多点触摸电容屏',    msg2: '15.6寸，分辨率1920*1080，多点触摸电容屏' },
        { img: require('../assets/equipment7.png'), name: '天波 TPS650 单屏',    category: 'PC 收银台', msg1: '15.6寸，分辨率1920*1080，多点触摸电容屏',    msg2: '无' },
        { img: require('../assets/equipment8.png'), name: '方派 FP-VS100',       category: '便携终端', msg1: '10.1寸，分辨率800*1280，多点触控',           msg2: '无' },
      ],
    }
  },

  mounted() {
    this.$nextTick(() => {
      this._initCursorGlow()
      this._initHeroAnimations()
      this._initSectionHead()
      this._initEquipCards()
      this._initCard3DTilt()
      this._initMagnetic()
    })
  },

  beforeDestroy() {
    ScrollTrigger.getAll().forEach(t => t.kill())
    document.removeEventListener('mousemove', this._cursorHandler)
  },

  methods: {
    /* ─── 鼠标光晕 ─── */
    _initCursorGlow() {
      const glow = this.$refs.cursorGlow
      if (!glow) return
      this._cursorHandler = (e) => {
        gsap.to(glow, { x: e.clientX, y: e.clientY, duration: 0.6, ease: 'power2.out' })
      }
      document.addEventListener('mousemove', this._cursorHandler)
    },

    /* ─── Hero 入场 ─── */
    _initHeroAnimations() {
      /* 光球浮动 */
      if (this.$refs.orb1) gsap.to(this.$refs.orb1, { y: -50, x: 25, duration: 5, repeat: -1, yoyo: true, ease: 'sine.inOut' })
      if (this.$refs.orb2) gsap.to(this.$refs.orb2, { y: 40, x: -30, duration: 6.5, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: 1 })

      const tl = gsap.timeline({ delay: 0.2 })
      tl.from(this.$refs.heroBadge, { scale: 0, opacity: 0, duration: 0.5, ease: 'back.out(2)' })
        .from('.clip-inner', { yPercent: 105, opacity: 0, duration: 0.9, ease: 'expo.out', stagger: 0.18 }, '-=0.2')
        .from(this.$refs.heroActions?.children || [], { y: 24, opacity: 0, duration: 0.5, ease: 'power3.out', stagger: 0.1 }, '-=0.4')
        .from(this.$refs.heroStats?.children || [], { y: 20, opacity: 0, duration: 0.5, ease: 'power3.out', stagger: 0.08 }, '-=0.3')

      /* 数字计数 */
      this.$el.querySelectorAll('.hero__stat-num').forEach((el) => {
        gsap.fromTo(el, { innerHTML: 0 }, {
          innerHTML: parseInt(el.dataset.target, 10),
          duration: 2, ease: 'power2.out',
          snap: { innerHTML: 1 }, delay: 1.2,
        })
      })

      /* 视差 */
      gsap.to(this.$refs.orb1, { y: -100, ease: 'none',
        scrollTrigger: { trigger: this.$refs.hero, scrub: 1, start: 'top top', end: 'bottom top' } })
    },

    /* ─── Section 标题揭示 ─── */
    _initSectionHead() {
      const label = this.$el.querySelector('.reveal-chip')
      const titleInner = this.$el.querySelector('.title-mask__inner')
      const desc = this.$refs.secDesc

      if (label) {
        gsap.fromTo(label, { x: -20, opacity: 0 },
          { x: 0, opacity: 1, duration: 0.6, ease: 'power3.out',
            scrollTrigger: { trigger: label, start: 'top 88%', once: true }, clearProps: 'transform,opacity' })
      }
      if (titleInner) {
        gsap.fromTo(titleInner, { yPercent: 110 },
          { yPercent: 0, duration: 1, ease: 'expo.out',
            scrollTrigger: { trigger: titleInner, start: 'top 88%', once: true }, clearProps: 'transform' })
      }
      if (desc) {
        gsap.fromTo(desc, { y: 16, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out', delay: 0.3,
            scrollTrigger: { trigger: desc, start: 'top 90%', once: true }, clearProps: 'transform,opacity' })
      }
    },

    /* ─── 设备卡片：scrub 时间线错落入场 ─── */
    _initEquipCards() {
      const cards = Array.from(this.$el.querySelectorAll('.equip-card'))
      if (!cards.length) return

      /* 构建 scrub timeline，随滚动逐列浮出 */
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cards[0],
          start: 'top 88%',
          end: 'top 30%',
          scrub: 0.7,
        },
      })
      cards.forEach((card, i) => {
        tl.fromTo(card,
          { y: 80, opacity: 0, scale: 0.88 },
          { y: 0, opacity: 1, scale: 1, duration: 0.5, ease: 'power3.out' },
          i * 0.04
        )
      })

      /* 每张卡片图片单独做内部发光脉冲 */
      cards.forEach((card) => {
        const glow = card.querySelector('.equip-card__glow')
        if (glow) {
          gsap.fromTo(glow,
            { opacity: 0.3 },
            {
              opacity: 0.7, duration: 2.5, repeat: -1, yoyo: true,
              ease: 'sine.inOut',
              delay: Math.random() * 2,
            }
          )
        }
      })
    },

    /* ─── 卡片 3D 倾斜 hover ─── */
    _initCard3DTilt() {
      const cards = this.$el.querySelectorAll('.equip-card')
      cards.forEach((card) => {
        card.addEventListener('mousemove', (e) => {
          const r = card.getBoundingClientRect()
          const x = (e.clientX - r.left) / r.width  - 0.5
          const y = (e.clientY - r.top)  / r.height - 0.5
          gsap.to(card, {
            rotateY: x * 16, rotateX: -y * 16,
            transformPerspective: 900,
            duration: 0.3, ease: 'power2.out',
          })
          /* stage 区域额外加强发光 */
          const glow = card.querySelector('.equip-card__glow')
          if (glow) gsap.to(glow, { opacity: 1, scale: 1.3, duration: 0.3 })
        })
        card.addEventListener('mouseleave', () => {
          gsap.to(card, {
            rotateY: 0, rotateX: 0,
            duration: 0.7, ease: 'elastic.out(1, 0.6)',
          })
          const glow = card.querySelector('.equip-card__glow')
          if (glow) gsap.to(glow, { opacity: 0.5, scale: 1, duration: 0.5 })
        })
      })
    },

    /* ─── 磁性按钮 ─── */
    _initMagnetic() {
      this.$el.querySelectorAll('.magnetic').forEach((btn) => {
        btn.addEventListener('mousemove', (e) => {
          const r = btn.getBoundingClientRect()
          gsap.to(btn, {
            x: (e.clientX - r.left - r.width  / 2) * 0.35,
            y: (e.clientY - r.top  - r.height / 2) * 0.35,
            duration: 0.3, ease: 'power2.out',
          })
        })
        btn.addEventListener('mouseleave', () => {
          gsap.to(btn, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.5)' })
        })
      })
    },

    /** 弹出申请试用弹窗 */
    applyShow() {
      this.show = true
      this.noScroll()
    },
  },
}
</script>

<style lang="scss" scoped>
$blue:   #0E6EB8;
$blue-l: #38A0F5;
$dark:   #0D1B2E;
$tint:   #F0F7FF;
$muted:  #6B7280;
$r-xl:   1.25rem;
$tr:     all .3s cubic-bezier(.4,0,.2,1);

/* ─── 光晕 ─── */
.cursor-glow {
  position: fixed; width: 28rem; height: 28rem; border-radius: 50%;
  background: radial-gradient(circle, rgba(14,110,184,.1), transparent 70%);
  pointer-events: none; transform: translate(-50%,-50%); z-index: 9990;
  mix-blend-mode: screen; will-change: transform;
}

/* ─── Hero ─── */
.hero {
  height: 44rem;
  background: url('../assets/equipment9.png') no-repeat center center / cover;
  position: relative; display: flex; align-items: center; overflow: hidden;

  .orb {
    position: absolute; border-radius: 50%; filter: blur(90px);
    pointer-events: none; z-index: 1; will-change: transform;
  }
  .orb--1 { width: 38rem; height: 38rem; background: rgba(14,110,184,.28); top: -10rem; right: -4rem; }
  .orb--2 { width: 24rem; height: 24rem; background: rgba(56,160,245,.2); bottom: 2rem; left: 40%; }

  &__overlay {
    position: absolute; inset: 0; z-index: 1;
    background: linear-gradient(110deg, rgba(8,28,60,.82) 0%, rgba(14,110,184,.38) 55%, rgba(0,0,0,.06) 100%);
  }
  &__body  { position: relative; z-index: 3; padding: 0 7.5rem; max-width: 60%; }
  &__badge {
    display: inline-flex; align-items: center; gap: .5rem;
    background: rgba(255,255,255,.12); backdrop-filter: blur(12px);
    border: 1px solid rgba(255,255,255,.25); color: #fff;
    font-size: .78rem; font-weight: 600; letter-spacing: .08em;
    padding: .38rem .95rem; border-radius: 5rem; margin-bottom: 1.2rem;
  }
  &__dot { width: .45rem; height: .45rem; border-radius: 50%; background: $blue-l; animation: pulse 2s infinite; }
  &__title {
    font-size: 2.5rem; font-weight: 800; color: #fff;
    line-height: 1.4; margin: 0 0 .6rem; text-shadow: 0 2px 20px rgba(0,0,0,.35);
  }
  &__sub   { font-size: .78rem; color: rgba(255,255,255,.7); letter-spacing: .06em; margin: 0 0 2rem; }
  &__actions { display: flex; gap: 1rem; margin-bottom: 2.5rem; }
  &__stats {
    display: flex; gap: 3rem; align-items: center;
    padding-top: 2rem; border-top: 1px solid rgba(255,255,255,.15);
  }
  &__stat-row  { display: flex; align-items: baseline; gap: .2rem; margin-bottom: .25rem; }
  &__stat-num  { font-size: 2rem; font-weight: 900; color: #fff; line-height: 1; }
  &__stat-unit { font-size: .9rem; font-weight: 700; color: $blue-l; }
  &__stat-label { font-size: .75rem; color: rgba(255,255,255,.55); letter-spacing: .06em; }
}

.clip-wrap { overflow: hidden; line-height: 1; }
.clip-inner { display: block; }

/* ─── 按钮 ─── */
.btn-primary {
  padding: .9rem 2.4rem; background: linear-gradient(135deg, $blue, $blue-l);
  color: #fff; font-size: .95rem; font-weight: 700; border-radius: 3rem;
  border: none; cursor: pointer; box-shadow: 0 6px 20px rgba(14,110,184,.4);
  transition: $tr; will-change: transform;
  &:hover { box-shadow: 0 10px 30px rgba(14,110,184,.55); }
}
.btn-ghost {
  padding: .9rem 2.4rem; background: rgba(255,255,255,.12); color: #fff;
  font-size: .95rem; font-weight: 700; border-radius: 3rem;
  border: 1.5px solid rgba(255,255,255,.45); cursor: pointer;
  transition: $tr; backdrop-filter: blur(8px); will-change: transform;
  &:hover { background: rgba(255,255,255,.22); border-color: #fff; }
}

/* ─── Section ─── */
.products-section {
  background: linear-gradient(180deg, $tint 0%, #fff 100%);
  padding: 0 0 6rem;
}
.sec__inner { max-width: 1400px; margin: 0 auto; padding: 0 7.5rem; }
.sec__head  { text-align: center; padding: 5rem 0 4rem; }

.sec__label {
  display: inline-block; font-size: .72rem; font-weight: 700; letter-spacing: .2em;
  color: $blue; background: rgba(14,110,184,.09);
  padding: .3rem .9rem; border-radius: 5rem; margin-bottom: .8rem;
}
.title-mask { overflow: hidden; margin-bottom: .7rem; }
.title-mask__inner {
  display: block; font-size: 2.4rem; font-weight: 800; color: #1A2535; margin: 0;
}
.sec__desc { font-size: .95rem; color: $muted; margin: 0; }

/* ─── 设备网格 ─── */
.equip-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

/* ─── 设备卡片 ─── */
.equip-card {
  background: #fff;
  border: 1px solid rgba(14,110,184,.1);
  border-radius: $r-xl;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(14,110,184,.08);
  transition: box-shadow .35s ease, border-color .35s ease;
  cursor: default;
  will-change: transform;
  transform-style: preserve-3d;

  &:hover {
    box-shadow: 0 22px 55px rgba(14,110,184,.22);
    border-color: rgba(14,110,184,.35);

    .equip-card__img { transform: scale(1.07) translateY(-3%); }
    .equip-card__bar { transform: scaleX(1.8); }
    .equip-card__stage { background: linear-gradient(180deg, #101e35 0%, #0d2a4a 100%); }
  }

  /* 深色产品展示台 */
  &__stage {
    position: relative;
    height: 14rem;
    background: linear-gradient(180deg, #0D1B2E 0%, #0e2240 100%);
    display: flex; align-items: center; justify-content: center;
    overflow: hidden;
    transition: background .4s ease;
  }

  /* 底部发光圈 */
  &__glow {
    position: absolute;
    bottom: -.5rem; left: 50%;
    transform: translateX(-50%);
    width: 60%; height: 3.5rem;
    background: radial-gradient(ellipse, rgba(56,160,245,.45), transparent 70%);
    border-radius: 50%;
    will-change: opacity, transform;
    opacity: 0.5;
  }

  /* 设备图片 */
  &__img {
    position: relative; z-index: 1;
    max-width: 75%; max-height: 88%;
    object-fit: contain;
    filter: drop-shadow(0 10px 22px rgba(56,160,245,.3));
    transition: transform .5s cubic-bezier(.4,0,.2,1);
    will-change: transform;
  }

  /* 品类角标 */
  &__cat {
    position: absolute; top: 1rem; left: 1rem; z-index: 2;
    background: rgba(56,160,245,.2); backdrop-filter: blur(10px);
    border: 1px solid rgba(56,160,245,.35); color: $blue-l;
    font-size: .68rem; font-weight: 700; letter-spacing: .08em;
    padding: .25rem .75rem; border-radius: 5rem;
  }

  /* 内容区 */
  &__body {
    position: relative;
    padding: 1.5rem 1.75rem 1.75rem;
    overflow: hidden;
  }

  /* 背景大序号 */
  &__bg-num {
    position: absolute; top: .5rem; right: 1.25rem;
    font-size: 5rem; font-weight: 900; line-height: 1;
    color: rgba(14,110,184,.06); pointer-events: none;
    letter-spacing: -.05em; user-select: none;
  }

  &__name {
    font-size: 1.05rem; font-weight: 800; color: #1A2535;
    margin: 0 0 .75rem; position: relative; z-index: 1;
  }

  &__bar {
    width: 2.5rem; height: 3px;
    background: linear-gradient(90deg, $blue, $blue-l);
    border-radius: 3px; margin-bottom: 1.25rem;
    transform-origin: left;
    transition: transform .4s ease;
  }

  &__specs {
    display: flex; flex-direction: column; gap: .6rem;
  }
}

/* ─── 规格行 ─── */
.spec-row {
  display: flex; align-items: flex-start; gap: .55rem;
}
.spec-badge {
  flex-shrink: 0;
  font-size: .68rem; font-weight: 700; letter-spacing: .04em;
  padding: .2rem .55rem; border-radius: .35rem;

  &--main { color: $blue;  background: rgba(14,110,184,.1); }
  &--sub  { color: $muted; background: rgba(107,114,128,.1); }
  &--none { color: #c0c0c0; background: rgba(0,0,0,.05); }
}
.spec-text {
  font-size: .82rem; color: $muted; line-height: 1.5;
  &--none { color: #ccc; font-style: italic; }
}

/* ─── Keyframes ─── */
@keyframes pulse {
  0%,100% { opacity: 1; transform: scale(1); }
  50%      { opacity: .5; transform: scale(1.4); }
}
</style>

<style>
@media screen and (max-width: 600px) {
  .cursor-glow { display: none; }
  .equipment-page .hero { margin-top: 70px; min-height: 30rem; height: auto !important; padding: 3rem 0; }
  .hero__body  { padding: 0 1.5rem !important; max-width: 100% !important; }
  .hero__stats { gap: 1.5rem !important; flex-wrap: wrap; }
  .equip-grid  { grid-template-columns: 1fr !important; }
  .sec__inner  { padding: 0 1.5rem !important; }
  .equip-card__stage { height: 12rem; }
}
</style>
